import React, {useEffect} from "react";

const ProcessingSummary = ({
                               fileData,
                               headerMapping,
                               isProcessing,
                               error,
                               eventId,
                               recordCount,
                               onStartOver,
                               onBackToMapping,
                               onProcessComplete,
                               onProcessError,
                           }) => {
    useEffect(() => {
        const process_rows = async () => {
            try {
                const transformed = fileData.data.map((row) => {
                    const submission = {};
                    Object.entries(headerMapping).forEach(([systemField, column]) => {
                        submission[systemField] = row[column];
                    });
                    return submission;
                });

                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/process-excel/${localStorage.getItem("universityId")}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: JSON.stringify({
                        event_id: eventId,
                        fileName: fileData.fileName,
                        data: transformed, // now keys are system keys
                    }),
                });

                const result = await response.json();
                onProcessComplete(result.batchId, result.recordCount);
            } catch (err) {
                onProcessError("Failed to process data"+err);
            }
        };

        if (isProcessing) {
            process_rows();
        }
    }, [isProcessing]);

    if (isProcessing) {
        return <p>⏳ Processing your file...</p>;
    }

    if (error) {
        return (
            <div>
                <p className="error-text">{error}</p>
                <button className="btn btn-secondary" onClick={onBackToMapping}>Back</button>
                <button className="m-2 btn btn-primary" onClick={onStartOver}>Start Over</button>
            </div>
        );
    }

    return (
        <div>
            <h3>✅ Upload Complete</h3>
            <p className="m-2">Records processed: {recordCount} </p>
            <h4 className="m-2">Field Mappings:</h4>
            <ul>
                {Object.entries(headerMapping).map(([sysField, column]) => (
                    <li className="m-2" key={sysField}>
                        {sysField}: <strong className="ml-2">{column}</strong>
                    </li>
                ))}
            </ul>
            <button className="btn btn-primary m-2" onClick={onStartOver}>Upload Another File</button>
        </div>
    );
};

export default ProcessingSummary;
